import React from "react";
import { useChat } from "../../contexts/ChatProvider";
import { useLocale } from "../../contexts/LocaleProvider";

const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    backgroundColor: "rgba(15, 15, 20, 0.55)",
    margin: "8px",
    borderRadius: "10px",
    // backdropFilter: "blur(2px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
    margin: "16px",
  },
  modal: {
    backgroundColor: "#ffffff",
    borderRadius: "12px",
    boxShadow: "0 8px 30px rgba(0, 0, 0, 0.25)",
    width: "calc(100vw - 64px)",
    maxWidth: "420px",
    padding: "24px",
    textAlign: "center",
    fontFamily:
      "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  },
  title: {
    fontSize: "18px",
    fontWeight: 600,
    color: "#1a1a1a",
    margin: "0 0 8px",
  },
  message: {
    fontSize: "14px",
    color: "#555555",
    lineHeight: 1.5,
    margin: "0 0 24px",
  },
  buttonRow: {
    display: "flex",
    gap: "10px",
    justifyContent: "flex-end"
  },
  primaryButton: {
    border: "none",
    borderRadius: "6px",
    padding: "8px 16px",
    cursor: "pointer",
  },
  secondaryButton: {
    // flex: 1,
    padding: "8px 16px",
    borderRadius: "8px",
    border: "1px solid #d9d9d9",
    backgroundColor: "#ffffff",
    color: "#333333",
    cursor: "pointer",
  },
};

export default function SessionExpiredModal({
  onCreateNewChat,
  onClose,
}) {
  const { t } = useLocale();
  const { theme } = useChat();
  return (
    <div style={styles.overlay}>
      <div style={styles.modal} role="dialog" aria-modal="true">
        <h2 style={styles.title}> {t("sessionExpired.modalTitle")} </h2>
        <p style={styles.message}>{t("sessionExpired.modalMessage")}</p>
        <div style={styles.buttonRow}>
          <button style={styles.secondaryButton} onClick={onClose}>
            {t("common.close")}
          </button>
          <button style={{...styles.primaryButton, background: theme}} onClick={onCreateNewChat}>
            {t("sessionExpired.createButton")}
          </button>
        </div>
      </div>
    </div>
  );
}